import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";
import {
  getVehicleById,
  updateVehicleStatus,
} from "../../../../API/FleetManager/Vehicles";
import {
  ArrowLeftOutlined,
  CloseCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Switch,
  notification,
  Popconfirm,
  InputNumber,
  Input,
} from "antd";
import {
  LockOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { BsThreeDotsVertical } from "react-icons/bs";
import makeIcon from "../../../../Assets/Icons/make-icon.svg";
import modelIcon from "../../../../Assets/Icons/graph_8.svg";
import yearIcon from "../../../../Assets/Icons/calendar_month.svg";
import vinIcon from "../../../../Assets/Icons/Vin.svg";
import vehicleIcon from "../../../../Assets/Icons/car_crash.svg";
import licenseIcon from "../../../../Assets/Icons/license.svg";
import fuelIcon from "../../../../Assets/Icons/gas_meter.svg";
import tankIcon from "../../../../Assets/Icons/propane.svg";
import driverIcon from "../../../../Assets/Icons/id_card.svg";
import creditIcon from "../../../../Assets/Icons/local_gas_station.svg";
import navixyApiKeyIcon from "../../../../Assets/Icons/password_2.svg";
import navixyTrackerIdIcon from "../../../../Assets/Icons/numbers.svg";
import docIcon from "../../../../Assets/Icons/document.svg";
import pdfIcon from "../../../../Assets/Icons/pdf.svg";
import GenericModal from "../../../../Components/Modals/GenericModal";
import pdfFile from "../../../../Assets/Files/file-sample.pdf";
import docxFile from "../../../../Assets/Files/file-sample.docx";
import cardIcon from "../../../../Assets/Icons/credit_card.svg";
import refuelIcon from "../../../../Assets/Icons/Container.svg";
import resetIcon from "../../../../Assets/Icons/reset.svg";
import "./style.css";
import GenericDocumentManagerTable from "../../../../Components/Tables/GenericDocumentManagerTable";
import StackedBarChart from "../../../../Components/Charts/StackedBarChart";
import usePageAccess from "../../../../Utlis/usePageAccess";
import { getInitials } from "../../../../Components/InitialsAvatar";
import VehicleQRCode from "../../../../Components/VehicleQRCode";
import GenericTable from "../../../../Components/Tables/GenericTable";

const HISTORY_TYPE_LABELS = {
  credit_added: "Credit Added",
  credit_removed: "Credit Removed",
  fueling: "Fueling",
};

const fmtMoney = (val, currency) => {
  const n = parseFloat(val);
  return Number.isNaN(n) ? "-" : `${currency || ""} ${n.toFixed(2)}`.trim();
};

const formatDateTime = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};


const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_URL?.replace(
  /\/?api\/?$/,
  "",
);

const resolveAvatarUrl = (avatar) => {
  if (!avatar) return null;
  if (/^https?:\/\//i.test(avatar) || avatar.startsWith("blob:")) {
    return avatar;
  }
  return `${BACKEND_ORIGIN}${avatar.startsWith("/") ? "" : "/"}${avatar}`;
};

const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : str;

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const formatCardExpiry = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "-";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  return `${mm} / ${yy}`;
};

const formatCardNumber = (num) => {
  if (!num) return "-";
  return num.match(/.{1,4}/g)?.join("  ") || num;
};

const maskCardNumber = (num) => {
  if (!num) return "-";
  const last4 = num.slice(-4);
  return `∗ ∗ ∗ ∗   ∗ ∗ ∗ ∗   ∗ ∗ ∗ ∗   ${last4.split("").join(" ")}`;
};

const formatCurrency = (val) => {
  const num = parseFloat(val);
  return Number.isNaN(num) ? "-" : `$${num.toFixed(2)}`;
};

const AVATAR_COLORS = [
  "#4F46E5",
  "#EA580C",
  "#16A34A",
  "#DC2626",
  "#2563EB",
  "#7C3AED",
];
const getAvatarColor = (name) =>
  AVATAR_COLORS[(name || "A").charCodeAt(0) % AVATAR_COLORS.length];

const VehicleDetail = () => {
  const { canEdit } = usePageAccess("vehicles");
  const navigate = useNavigate();
  const location = useLocation();
  const passedId = location.state?.id;
  const qr = location.state?.qr || {
    fleetManager: "Fleet #123",
    vehicles: "SL-102 (Heavy Hauler)",
    plateNumber: "CA-8892XL",
    cardNumber: "4281",
    status: "Active",
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isFuelModalOpen, setIsFuelModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isInactivated, setIsInactivated] = useState(false);
  const [reason, setReason] = useState("Due to a credit threshold breach");
  const [timeFilter, setTimeFilter] = useState("Daily");
  const [fuelType, setFuelType] = useState("All");
  const [showCardNumber, setShowCardNumber] = useState(false);
  const [frozen, setFrozen] = useState(false);
  const [freezeModalOpen, setFreezeModalOpen] = useState(false);
  const qrRef = useRef(null);

  const [vehicle, setVehicle] = useState({
    make: "-",
    model: "-",
    year: "-",
    vin: "-",
    licensePlate: "-",
    qrCode: "",
    vehicleType: "-",
    fuelType: "-",
    tankCapacity: "-",
    status: "-",
    avatar: null,
    driverName: "-",
    driverId: null,
    vehicleId: "-",
    fuelCard: null,
    creditBalance: "-",
    creditUsed: "-",
    navixyApiKey: "-",
    navixyTrackerId: "-",
  });

  const [fuelUsage, setFuelUsage] = useState({ labels: [], volume: [], spend: [] });
  const [creditHistory, setCreditHistory] = useState(null);
  const [historyLoading, setHistoryLoading] = useState(false);

  const fetchVehicle = async (period) => {
    setHistoryLoading(true);
    try {
      const res = await getVehicleById(passedId, period);
      const data = res?.data?.data;

      if (Math.floor(res?.status / 100) === 2 && data) {
        setCreditHistory(data.credit_history || null);
        setVehicle({
          make: data.make || "-",
          model: data.model || "-",
          year: data.year || "-",
          vin: data.vin || "-",
          licensePlate: data.license_plate || "-",
          qrCode: data.qr_code || "",
          vehicleType: data.vehicle_type || "-",
          fuelType: data.fuel_type_name || "-",
          tankCapacity: data.tank_capacity
            ? `${Number(data.tank_capacity)} (L)`
            : "-",
          status: capitalize(data.status) || "-",
          avatar: resolveAvatarUrl(data.avatar),
          driverName:
            data.driver?.name ||
            (typeof data.driver === "string" ? data.driver : "-"),
          driverId: data.driver?.id ?? null,
          vehicleId: data.vehicle_id || "-",
          fuelCard: data.fuel_card || null,
          creditBalance: formatCurrency(data.credit_balance),
          creditUsed: formatCurrency(data.credit_used),
          navixyApiKey: data.navixy_api_key || "-",
          navixyTrackerId: data.navixy_tracker_id || "-",
        });

        setIsInactivated(data.status === "inactive");
        setReason(data.inactive_reason || "");

        const byFuelType = data.fuel_usage?.by_fuel_type;
        setFuelUsage({
          labels: byFuelType?.labels || [],
          volume: (byFuelType?.total_volume || []).map(
            (v) => parseFloat(v) || 0,
          ),
          spend: (byFuelType?.total_amount || []).map(
            (v) => parseFloat(v) || 0,
          ),
        });

        if (data.fuel_card) {
          setCreditData({
            is_active: !!data.fuel_card.is_active,
            card_number: formatCardNumber(data.fuel_card.card_number),
            daily_limit: parseFloat(data.fuel_card.daily_limit) || 0,
            daily_limit_enabled: !!data.fuel_card.daily_limit_enabled,
            monthly_limit: parseFloat(data.fuel_card.monthly_limit) || 0,
            monthly_limit_enabled: !!data.fuel_card.monthly_limit_enabled,
            weekly_limit: parseFloat(data.fuel_card.weekly_limit) || 0,
            weekly_limit_enabled: !!data.fuel_card.weekly_limit_enabled,
            weekend_limit: parseFloat(data.fuel_card.weekend_limit) || 0,
            weekend_limit_enabled: !!data.fuel_card.weekend_limit_enabled,
            allow_any_driver: !!data.fuel_card.allow_any_driver,
            auto_reset: !!data.fuel_card.auto_reset,
          });
        }

        if (Array.isArray(data.documents)) {
          setDocuments(
            data.documents.map((doc) => {
              const label = capitalize(
                (doc.category || "Document").replace(/_/g, " "),
              );

              return {
                key: String(doc.id),
                name: doc.file ? doc.file.split("/").pop() : label,
                category: label,
                date: formatDate(doc.uploaded_at),
                expiryDate: formatDate(doc.expiry_date),
                fileUrl: resolveAvatarUrl(doc.file),
              };
            }),
          );
        }
      } else {
        message.error(res?.data?.message || "Failed to load vehicle.");
      }
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Failed to load vehicle.",
      );
    } finally {
      setHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (!passedId) {
      message.error(
        "No vehicle selected. Please open this page from the Vehicles list.",
      );
      return;
    }

    fetchVehicle(timeFilter.toLowerCase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passedId]);

  const handleTimeFilterClick = (tab) => {
    setTimeFilter(tab);
    fetchVehicle(tab.toLowerCase());
  };

  const historyCurrency = creditHistory?.currency || "";

  const getFuelingSummary = (record) =>
    [
      record.fuel_type_name,
      record.volume != null ? `${record.volume} L` : null,
      record.fuel_vendor_name,
    ]
      .filter(Boolean)
      .join(" · ");

  const historyRows = (creditHistory?.entries || []).map((e, i) => ({
    key: `${e.entry_type}-${e.transaction_id ?? i}-${e.created_at}`,
    ...e,
    type_label: e.source_display || HISTORY_TYPE_LABELS[e.entry_type] || e.entry_type,
    details:
      e.entry_type === "fueling"
        ? [getFuelingSummary(e), e.txn_id].filter(Boolean).join(" ")
        : e.reason || "",
  }));

  const toNumber = (value) => {
    const n = parseFloat(value);
    return Number.isNaN(n) ? -Infinity : n;
  };

  const getUniqueFilters = (key) =>
    [...new Set(historyRows.map((row) => row[key]).filter(Boolean))].map(
      (value) => ({ text: value, value }),
    );

  const historyColumns = [
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) =>
        (new Date(a.created_at).getTime() || 0) -
        (new Date(b.created_at).getTime() || 0),
      render: (value) => formatDateTime(value),
    },
    {
      title: "Type",
      dataIndex: "type_label",
      key: "type_label",
      filters: Object.entries(HISTORY_TYPE_LABELS).map(([value, text]) => ({
        text,
        value,
      })),
      onFilter: (value, record) => record.entry_type === value,
      render: (label, record) => (
        <span
          className={`credit-history__type credit-history__type--${record.entry_type}`}
        >
          {label}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => toNumber(a.amount) - toNumber(b.amount),
      render: (amount, record) => {
        const isIn = record.entry_type === "credit_added";
        return (
          <span
            className={`credit-history__amount credit-history__amount--${isIn ? "in" : "out"}`}
          >
            {isIn ? "+" : "−"} {fmtMoney(amount, historyCurrency)}
          </span>
        );
      },
    },
    {
      title: "Balance After",
      dataIndex: "balance_after",
      key: "balance_after",
      sorter: (a, b) => toNumber(a.balance_after) - toNumber(b.balance_after),
      render: (value) =>
        value == null ? "-" : fmtMoney(value, historyCurrency),
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      enableSearch: true,
      render: (_, record) => {
        if (record.entry_type !== "fueling") return record.reason || "-";
        const summary = getFuelingSummary(record);
        return (
          <div className="credit-history__details">
            <span>{summary || "-"}</span>
            {record.txn_id && (
              <span className="credit-history__txn">{record.txn_id}</span>
            )}
          </div>
        );
      },
    },
    {
      title: "Driver",
      dataIndex: "driver_name",
      key: "driver_name",
      enableSearch: true,
      render: (value) => value || "-",
    },
    {
      title: "Performed By",
      dataIndex: "performed_by_name",
      key: "performed_by_name",
      filters: getUniqueFilters("performed_by_name"),
      onFilter: (value, record) => record.performed_by_name === value,
      render: (value) => value || "-",
    },
  ];

  const handleHistoryRowClick = (record) => {
    if (record?.transaction_id == null) return;
    navigate("/transaction-manager-details", {
      state: { id: record.transaction_id },
    });
  };

  const handleBack = () => {
    navigate("/vehicles-manager");
  };

  const handleEditDriver = () => {
    if (!vehicle.driverId) {
      message.error("No driver assigned to this vehicle.");
      return;
    }

    navigate("/edit-driver", { state: { id: vehicle.driverId } });
  };

  const handleView = (record) => {
    if (!record?.fileUrl) return;

    const lowerName = record.name.toLowerCase();

    if (lowerName.endsWith(".pdf")) {
      // Open PDF in new tab
      window.open(record.fileUrl, "_blank", "noopener,noreferrer");
    } else {
      // Force download for other file types
      const link = document.createElement("a");
      link.href = record.fileUrl;
      link.download = record.name; // forces download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleDeleteDocument = (record) => {
    setSelectedRow(record);
    setIsDeleteModalOpen(true);
  };

  const handleToggleActivity = () => {
    if (!isInactivated) {
      setIsFuelModalOpen(true);
    }
  };

  const handleConfirmActivity = async (enteredReason) => {
    if (!passedId) return;

    try {
      const res = await updateVehicleStatus(passedId, {
        status: "inactive",
        inactive_reason: enteredReason,
      });

      if (Math.floor(res?.status / 100) === 2) {
        setIsInactivated(true);
        setReason(enteredReason);
        setIsFuelModalOpen(false);
        setVehicle((prev) => ({ ...prev, status: "Inactive" }));

        notification.success({
          message: "Vehicle Deactivated",
          description:
            res?.data?.message || "Vehicle has been deactivated successfully!",
          placement: "topRight",
        });
      } else {
        message.error(res?.data?.message || "Failed to deactivate vehicle.");
      }
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Failed to deactivate vehicle.",
      );
    }
  };

  const handleActivate = async () => {
    if (!passedId) return;

    try {
      const res = await updateVehicleStatus(passedId, {
        status: "active",
      });

      if (Math.floor(res?.status / 100) === 2) {
        setIsInactivated(false);
        setReason("");
        setVehicle((prev) => ({ ...prev, status: "Active" }));

        notification.success({
          message: "Vehicle Activated",
          description:
            res?.data?.message || "Vehicle has been activated successfully!",
          placement: "topRight",
        });
      } else {
        message.error(res?.data?.message || "Failed to activate vehicle.");
      }
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Failed to activate vehicle.",
      );
    }
  };
  const columns = [
    {
      title: "Document Name",
      dataIndex: "name",
      key: "name",
      enableSearch: true,
      render: (name) => {
        let icon = docIcon;
        const lowerName = name.toLowerCase();

        if (lowerName.endsWith(".pdf")) icon = pdfIcon;
        else if (
          lowerName.endsWith(".doc") ||
          lowerName.endsWith(".docx") ||
          lowerName.endsWith(".coc")
        )
          icon = docIcon;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <img src={icon} alt="doc icon" style={{ width: 20, height: 20 }} />
            <span>{name}</span>
          </div>
        );
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      filters: [
        { text: "License", value: "License" },
        { text: "Tax", value: "Tax" },
        { text: "Insurance", value: "Insurance" },
      ],
      onFilter: (value, record) => record.category === value,
      render: (category) => {
        let badgeClass = "";

        switch (category.toLowerCase()) {
          case "license":
            badgeClass = "badge-license";
            break;
          case "tax":
            badgeClass = "badge-tax";
            break;
          case "insurance":
            badgeClass = "badge-insurance";
            break;
          default:
            badgeClass = "badge-default";
        }

        return (
          <span className={`badge-category ${badgeClass}`}>{category}</span>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) =>
        (new Date(a.date).getTime() || 0) - (new Date(b.date).getTime() || 0),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: "Verified", value: "Verified" },
        { text: "Active", value: "Active" },
        { text: "Pending", value: "Pending" },
      ],
      onFilter: (value, record) => record.status === value,
      render: (status) => {
        let statusClass = "";

        if (status === "Verified") statusClass = "status-verified";
        else if (status === "Active") statusClass = "status-active";
        else statusClass = "status-pending";

        return <span className={statusClass}>{status}</span>;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const items = [
          canEdit && {
            key: "delete",
            label: "Remove",
            style: { color: "#DC2626", fontWeight: 500 },
            icon: <DeleteOutlined />,
            onClick: () => handleDeleteDocument(record),
          },
          {
            key: "view",
            label: "View",
            icon: <EyeOutlined />,
            style: { color: "#000000", fontWeight: 500 },
            onClick: () => handleView(record),
          },
        ].filter(Boolean);
        return (
          <>
            <Dropdown
              menu={{ items }}
              trigger={["click"]}
              placement="bottomRight"
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  width: 24,
                  height: 24,
                }}
              >
                <BsThreeDotsVertical
                  style={{ fontSize: 20, color: "#4F46E5" }}
                />
              </span>
            </Dropdown>
          </>
        );
      },
    },
  ];

  const [documents, setDocuments] = useState([
    {
      key: "1",
      name: "Business_License.pdf",
      category: "License",
      date: "Dec 31, 2021",
      status: "Verified",
      fileUrl: pdfFile,
    },
    {
      key: "2",
      name: "Tax_Registration.docx",
      category: "Tax",
      date: "Dec 31, 2022",
      status: "Verified",
      fileUrl: docxFile,
    },
    {
      key: "3",
      name: "Insurance_certificate.pdf",
      category: "Insurance",
      date: "Dec 31, 2015",
      status: "Active",
      fileUrl: pdfFile,
    },
    {
      key: "4",
      name: "Station_certificate.pdf",
      category: "Station",
      date: "Dec 31, 2025",
      status: "Active",
      fileUrl: pdfFile,
    },
  ]);

  const filteredData = (() => {
    const data = fuelUsage;

    if (fuelType !== "All") {
      const index = data.labels.findIndex((l) => l === fuelType);

      return {
        labels: [data.labels[index]],
        spend: [data.spend[index]],
      };
    }

    return data;
  })();

  const isReadOnly = false;

  const [creditData, setCreditData] = useState({
    is_active: false,
    card_number: "-",
    daily_limit: 0,
    daily_limit_enabled: false,
    monthly_limit: 0,
    monthly_limit_enabled: false,
    weekly_limit: 0,
    weekly_limit_enabled: false,
    weekend_limit: 0,
    weekend_limit_enabled: false,
    allow_any_driver: false,
    auto_reset: false,
  });

  const limitGridConfig = [
    {
      label: "Daily Spending Limit",
      sub: "Resets at 00:00 UTC",
      key: "daily_limit",
      toggle: "daily_limit_enabled",
    },
    {
      label: "Monthly Spending Limit",
      sub: "Resets 1st of month",
      key: "monthly_limit",
      toggle: "monthly_limit_enabled",
    },
    {
      label: "Weekly Spending Limit",
      sub: "Resets every Monday",
      key: "weekly_limit",
      toggle: "weekly_limit_enabled",
    },
    {
      label: "Weekend Rules",
      sub: "Restricted Sat/Sun",
      key: "weekend_limit",
      toggle: "weekend_limit_enabled",
      accent: "green-accent",
    },
  ];

  return (
    <div className="vehicle-detail">
      <div className="back-btn">
        <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
          Back
        </Button>
      </div>
      <div className="header-wrapper">
        <div className="title">Vehicle Detail</div>
        <div className="btns">
          {canEdit && (
            <div>
              {!isInactivated ? (
                <Button
                  className="fuel-btn"
                  icon={<CloseCircleOutlined />}
                  onClick={handleToggleActivity}
                >
                  Deactivate Vehicle
                </Button>
              ) : (
                <Popconfirm
                  title="Are you sure you want to activate this vehicle?"
                  onConfirm={handleActivate}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    className="fuel-btn enabled"
                    icon={<LockOutlined />}
                    style={{
                      color: "#16a34a",
                      backgroundColor: "#16a34a1a",
                    }}
                  >
                    Activate Vehicle
                  </Button>
                </Popconfirm>
              )}
            </div>
          )}

          {canEdit && (
            <div>
              <Button
                icon={<EditOutlined />}
                className="edit-btn"
                onClick={() =>
                  navigate("/edit-vehicle", { state: { id: passedId } })
                }
              >
                Edit Vehicle
              </Button>
            </div>
          )}

          {canEdit && (
            <div>
              <Button
                icon={<EditOutlined />}
                type="primary"
                className="edit-btn"
                onClick={handleEditDriver}
              >
                Edit Driver
              </Button>
            </div>
          )}
        </div>
      </div>
      {isInactivated && (
        <div className="locked-info">
          <div className="label">
            Inactive Reason
            <div className="reason"> {reason}</div>
          </div>
        </div>
      )}
      <GenericModal
        open={isFuelModalOpen}
        title="Deactivate Vehicle"
        subtitle="Are you sure you want to deactivate this vehicle? This will immediately decline all active card transactions."
        showReason={true}
        confirmText="Deactivate"
        cancelText="Go Back"
        iconColor="#ef4444"
        iconBgColor="#ef44441a"
        confirmBtnColor="#EA580C"
        onCancel={() => setIsFuelModalOpen(false)}
        onConfirm={handleConfirmActivity}
      />

      <div className="row">
        <div className="left-column">
          <div className="profile-card">
            <div className="profile-header">
              {vehicle.avatar ? (
                <img
                  src={vehicle.avatar}
                  alt={vehicle.make}
                  className="profile-avatar"
                  style={{ objectFit: "cover" }}
                />
              ) : (
                <div
                  className="profile-avatar"
                  style={{ background: getAvatarColor(vehicle.make) }}
                >
                  {getInitials(vehicle.make)}
                </div>
              )}
            </div>

            <div className="profile-body">
              <div className="company-name">
                {[vehicle.make, vehicle.model]
                  .filter((v) => v && v !== "-")
                  .join(" ") || "-"}
              </div>
              <div className="company-id">{vehicle.licensePlate}</div>

              <div
                style={{ display: "flex", gap: 8, justifyContent: "center" }}
              >
                <span className="badge badge-fuel">{vehicle.fuelType}</span>
                <span
                  className={`badge ${vehicle.status === "Active" ? "badge-active" : "badge-inactive"}`}
                >
                  {vehicle.status}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="right-column">
          <div className="info">
            <div className="info-card-right">
              <div className="info-grid-right">
                <div className="item">
                  <div className="card-wrapper">
                    <div className="icon">
                      <img src={makeIcon} alt="Make Icon" />
                    </div>
                    <div className="info-label">Make</div>
                  </div>
                  <div className="info-value">{vehicle.make}</div>
                </div>
                <div className="item">
                  <div className="card-wrapper">
                    <div className="icon">
                      <img src={modelIcon} alt="model Icon" />
                    </div>
                    <div className="info-label">Model</div>
                  </div>
                  <div className="info-value">{vehicle.model}</div>
                </div>
                <div className="item">
                  <div className="card-wrapper">
                    <div className="icon">
                      <img src={yearIcon} alt="year Icon" />
                    </div>
                    <div className="info-label">Year</div>
                  </div>
                  <div className="info-value">{vehicle.year}</div>
                </div>
                <div className="item">
                  <div className="card-wrapper">
                    <div className="icon">
                      <img src={vinIcon} alt="vin Icon" />
                    </div>
                    <div className="info-label">VIN</div>
                  </div>
                  <div className="info-value">{vehicle.vin}</div>
                </div>
                <div className="item">
                  <div className="card-wrapper">
                    <div className="icon">
                      <img src={licenseIcon} alt="Lic Icon" />
                    </div>
                    <div className="info-label">License Plate</div>
                  </div>
                  <div className="info-value">{vehicle.licensePlate}</div>
                </div>
                <div className="item">
                  <div className="card-wrapper">
                    <div className="icon">
                      <img src={vehicleIcon} alt="Vehicle Icon" />
                    </div>
                    <div className="info-label">Vehicle Type </div>
                  </div>
                  <div className="info-value">{vehicle.vehicleType}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="info">
        <div className="info-card">
          <div className="info-grid">
            <div className="item">
              <div className="card-wrapper">
                <div className="icon">
                  <img src={fuelIcon} alt="Fuel Icon" />
                </div>
                <div className="info-label">Fuel Type</div>
              </div>
              <div className="info-value">{vehicle.fuelType}</div>
            </div>

            <div className="item">
              <div className="card-wrapper">
                <div className="icon">
                  <img src={tankIcon} alt="tank Icon" />
                </div>
                <div className="info-label">Tank Capacity</div>
              </div>
              <div className="info-value">{vehicle.tankCapacity}</div>
            </div>
            <div className="item">
              <div className="card-wrapper">
                <div className="icon">
                  <img src={driverIcon} alt="Driver Icon" />
                </div>
                <div className="info-label">Assigned Driver</div>
              </div>
              <div className="info-value">{vehicle.driverName}</div>
            </div>

            <div className="item">
              <div className="card-wrapper">
                <div className="icon">
                  <img src={creditIcon} alt="credits Icon" />
                </div>
                <div className="info-label">Fuel Credits</div>
              </div>
              <div className="info-value">{vehicle.creditBalance}</div>
            </div>

            <div className="item">
              <div className="card-wrapper">
                <div className="icon">
                  <img src={navixyApiKeyIcon} alt="Navixy API Key Icon" />
                </div>
                <div className="info-label">Navixy API Key</div>
              </div>
              <div className="info-value">{vehicle.navixyApiKey}</div>
            </div>

            <div className="item">
              <div className="card-wrapper">
                <div className="icon">
                  <img src={navixyTrackerIdIcon} alt="Navixy Tracker ID Icon" />
                </div>
                <div className="info-label">Navixy Tracker ID</div>
              </div>
              <div className="info-value">{vehicle.navixyTrackerId}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="graph-card">
          <div className="chart-controls-header-simple">
            <div className="time-filter-pills">
              {["Daily", "Weekly", "Monthly", "Yearly"].map((tab) => (
                <button
                  key={tab}
                  className={`pill-button ${timeFilter === tab ? "active" : ""}`}
                  onClick={() => handleTimeFilterClick(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>

          <div className="bar-chart-container">
            <StackedBarChart
              graphData={{
                labels: filteredData.labels,
                Fuel_volume: filteredData.volume,
                Fuel_spend: filteredData.spend,
              }}
              lengthKeys={2}
              colourTheme={["#DC2626", "#4F46E5"]}
              graphTitle="Spend By Fuel Type"
              selectTenByDefault={false}
              defaultSelected={[vehicle.fuelType]}
              units={["L", "$"]}
              classNameCSS="quantity-to-use"
              grayzoned={true}
            />
          </div>
        </div>
      </div>

      <div className="row qr-card">
        {/* Left Side: QR Code Area */}
        <div className="qr-active-detail__qr-card" ref={qrRef}>
          <div className="qr-active-detail__qr-label">Your Active QR Code</div>
          <div className="qr-active-detail__qr-code">
            <VehicleQRCode
              code={vehicle.qrCode}
              licensePlate={vehicle.licensePlate}
              showDownload
            />
          </div>
          <div className="qr-active-detail__qr-sublabel">
            Scan at any Precision Terminal
          </div>
        </div>

        {/* Right Side: Fuel Card Data + Operations Container */}
        <div className="qr-active-detail__card-section">
          <div className="qr-active-detail__fuel-card">
            <div className="qr-active-detail__card-top">
              <div>
                <div className="qr-active-detail__card-type">
                  FLEET FUEL CARD
                </div>
                <div className="qr-active-detail__card-name">
                  PRECISION SENTINEL
                </div>
              </div>
              {/* Custom SVG Icon Container matches picture snippet layout */}
              <div className="qr-active-detail__card-nfc">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="rgba(255,255,255,0.15)"
                    strokeWidth="2"
                  />
                  <path
                    d="M9 15C9.5 13.5 10.5 12.5 12 12.5s2.5 1 3 2.5"
                    stroke="rgba(255,255,255,0.4)"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M7.5 17C8.5 14.5 10 13 12 13s3.5 1.5 4.5 4"
                    stroke="rgba(255,255,255,0.7)"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>

            <div className="qr-active-detail__card-number">
              {showCardNumber
                ? formatCardNumber(vehicle.fuelCard?.card_number)
                : maskCardNumber(vehicle.fuelCard?.card_number)}
            </div>

            <div className="qr-active-detail__card-footer">
              <div>
                <div className="qr-active-detail__card-footer-label">
                  BALANCE
                </div>
                <div className="qr-active-detail__card-footer-value">
                  {vehicle.creditBalance}
                </div>
              </div>
              <div>
                <div className="qr-active-detail__card-footer-label">
                  EXPIRY
                </div>
                <div className="qr-active-detail__card-footer-value">
                  {formatCardExpiry(vehicle.fuelCard?.expiry_date)}
                </div>
              </div>
              <div className="qr-active-detail__fleet-badge">
                {vehicle.licensePlate}
              </div>
            </div>
          </div>

          {/* Functional Buttons Layer */}
          <div className="qr-active-detail__card-actions">
            <button
              className="qr-active-detail__card-btn"
              onClick={() => setShowCardNumber(!showCardNumber)}
            >
              <EyeOutlined />
              {showCardNumber ? "Hide Card Number" : "Show Card Number"}
            </button>
            <button
              className={`qr-active-detail__card-btn ${frozen ? "frozen" : ""}`}
              onClick={() => setFrozen(!frozen)}
            >
              <StopOutlined />
              {frozen ? "Unfreeze Card" : "Freeze Card"}
            </button>
          </div>
        </div>
      </div>
      <div className="credit-controls">
        <div className="header-section">
          <div className="heading">Credit Controls</div>
        </div>

        <div className="control-row">
          <div
            className={`status-card ${creditData.is_active ? "active-card" : ""}`}
          >
            <div className="icon-box">
              <img src={cardIcon} alt="card Icon" />
            </div>
            <div className="wrapper">
              <div className="card-info">
                <div className="label-main">Active Fuel Card</div>
                <div className="label-sub">
                  Enable instant digital wallet payments
                </div>
              </div>
              <div>
                <Switch checked={creditData.is_active} disabled={isReadOnly} />
              </div>
            </div>
          </div>

          <div className="field-display">
            <div className="field-label">
              Fuel Card Number <span className="required">*</span>
            </div>
            <Input
              className="field-box"
              value={creditData.card_number}
              variant="borderless"
              disabled
            />
          </div>
        </div>

        <div className="limits-grid">
          {limitGridConfig.map((item) => (
            <div className={`limit-card ${item.accent || ""}`} key={item.key}>
              <div className="limit-header">
                <div>
                  <div className="limit-title">{item.label}</div>
                  <div className="limit-reset">{item.sub}</div>
                </div>
                <Switch
                  checked={creditData[item.toggle]}
                  disabled={isReadOnly}
                />
              </div>
              <div
                className="value-box"
                style={{ display: "flex", alignItems: "center" }}
              >
                <span className="currency">$</span>
                <InputNumber
                  variant="borderless"
                  controls={false}
                  value={creditData[item.key]}
                  disabled
                />
              </div>
            </div>
          ))}
        </div>

        <div className="advanced-section">
          <div className="section-tag">ADVANCED RULE LOGIC</div>
          <div className="logic-row">
            <div className="logic-item">
              <div className="logic-content">
                <div className="logic-icon">
                  <img src={refuelIcon} alt="refuel" />
                </div>
                <span>Allow Any Authorized Driver to Refuel</span>
              </div>
              <Switch
                checked={creditData.allow_any_driver}
                disabled={isReadOnly}
              />
            </div>
            <div className="logic-item">
              <div className="logic-content">
                <div className="logic-icon">
                  <img src={resetIcon} alt="reset" />
                </div>
                <span>Auto Reset Limits</span>
              </div>
              <Switch checked={creditData.auto_reset} disabled={isReadOnly} />
            </div>
          </div>
        </div>
      </div>

      {(creditHistory || historyLoading) && (
        <div className="credit-history">
          <div className="credit-history__table">
            <GenericTable
              title="Credit History"
              dataSource={historyRows}
              columns={historyColumns}
              loading={historyLoading}
              emptyText="No credit activity yet."
              rowClassName={(record) =>
                record.transaction_id != null
                  ? "credit-history__row--clickable"
                  : ""
              }
              onRowClick={handleHistoryRowClick}
            />
          </div>
        </div>
      )}

      <div className="document-table-fleet">
        <GenericDocumentManagerTable
          initialDocuments={documents}
          showTableOnly={true}
          hideRemoveAction={true}
        />

        <GenericModal
          open={isDeleteModalOpen}
          title="Remove Document"
          subtitle={`Are you sure you want to remove ${selectedRow?.name}?`}
          highlightText={selectedRow?.name}
          showReason={false}
          confirmText="Delete"
          cancelText="Cancel"
          iconColor="#DC2626"
          iconBgColor="#FEE2E2"
          confirmBtnColor="#DC2626"
          onCancel={() => setIsDeleteModalOpen(false)}
          onConfirm={() => {
            setIsDeleteModalOpen(false);
            setDocuments((prev) =>
              prev.filter((doc) => doc.key !== selectedRow.key),
            );
            notification.success({
              message: "Document Deleted",
              description: `${selectedRow?.name} has been successfully removed.`,
              placement: "topRight",
            });
          }}
        />
      </div>
    </div>
  );
};

export default VehicleDetail;
